import React, { useContext, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../context/auth-context';
import Button from '../Buttons/Button';
import Card from '../Cards/Card';
import mod from './Forms.module.css';
import Loading from '../Layouts/Loading';
import ErrorMessage from '../Layouts/ErrorMessage';

function LoginForm() {
	const usernameRef = useRef();
	const passwordRef = useRef();
	const navigate = useNavigate();
	const authCtx = useContext(AuthContext);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);

	async function submitHandler(e) {
		e.preventDefault();
		setIsLoading(true);
		const username = usernameRef.current.value;
		const password = passwordRef.current.value;
		const selectedUser = {
			username,
			password,
		};
		try {
			const response = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}/api/users/login`,
				{
					method: 'POST',
					headers: {
						'Content-type': 'application/json',
					},
					body: JSON.stringify(selectedUser),
				}
			);
			const responseData = await response.json();
			if (!response.ok) {
				throw new Error(responseData.message);
			} else {
				if (responseData.login === true) {
					authCtx.login(responseData.user);
					setIsLoading(false);
					navigate('/chatapp');
				}
			}
		} catch (e) {
			setError(e.message);
			setTimeout(() => {
				setIsLoading(false);
				setError(null);
			}, 3000);
		}
	}

	return (
		<Card className={mod.FormCard}>
			{isLoading && <Loading />}
			{!isLoading && (
				<form className={mod.form} onSubmit={submitHandler}>
					<div className={mod.element}>
						<label htmlFor='username'>Username:</label>
						<input
							type='text'
							id='username'
							ref={usernameRef}
							required
							placeholder='Username'
						/>
					</div>
					<div className={mod.element}>
						<label htmlFor='password'>Password:</label>
						<input
							type='password'
							id='password'
							ref={passwordRef}
							required
							placeholder='Password'
						/>
					</div>
					<div className={mod.element}>
						<Button type='submit'>Start</Button>
					</div>
				</form>
			)}
			{error && <ErrorMessage message={error} />}
		</Card>
	);
}

export default LoginForm;
